<ng-container *transloco="let t;">
  <app-detail-view [loading]="loading" [messages]="messages" (closed)="onClose()">

    <div title>
      <h1>
        <span *ngIf="editMode()">{{ t('common.labels.onlinetest') }} <strong>{{ onlinetest.name }}</strong></span>
      </h1>
    </div>

    <div details>
      <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="tabIndex">

        <p-tabPanel header="{{ t('common.labels.basedata') }}" leftIcon="pi pi-sliders-h" [disabled]="isDisabled('basedata')">
          <app-onlinetest-basedata *ngIf="editMode()" [onlinetest]="onlinetest" [competences]="competences"></app-onlinetest-basedata>
        </p-tabPanel>

        <p-tabPanel header="{{ t('common.labels.competences') }}" leftIcon="pi pi-palette" [disabled]="isDisabled('competences')">
          <app-onlinetest-competences [onlinetest]="onlinetest" [competences]="competences"></app-onlinetest-competences>
        </p-tabPanel>

      </p-tabView>
    </div>

  </app-detail-view>
</ng-container>
